import { render } from "./LoginButton.vue?vue&type=template&id=637a2c7e"
const script = {}

const cssModules = {}
import style0 from "./LoginButton.vue?vue&type=style&index=0&id=637a2c7e&lang=scss&module=true"
cssModules["$style"] = style0

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__cssModules',cssModules]])

export default __exports__